const Logo = ({width, src = '/img/Logo.png'})=>{
    return <img width={width ? width : '90' } src={src} alt='planium' />

}
export default Logo;
